import React from 'react'
import styled, { css } from 'styled-components'
import { Container } from '@rst/ui-ts'
import { Col, Row } from 'react-grid-system'
import { Body } from '../molecules/body'
import { TemplateProps } from '../type'
import { Scroll } from '../atoms/page-scroll'

export const TemplateDesktop: React.FC<TemplateProps> = ({
	onScroll,
	width,
	...props
}) => {
	const size = props.desktop?.size || 6
	const justify = props.desktop?.justify || 'center'
	const isLightBox = props.desktop?.isLightBox || false
	const lightBoxPosition = props.desktop?.lightBoxPosition || 'right'

	if (isLightBox)
		return (
			<Scroll
				close={props.close}
				onScroll={onScroll}
				className={props.className}
				modalType={props.modalType}
				shouldCloseBg={props.shouldCloseBg}
				preventDefault={props.preventDefault}
			>
				<LightBox>
					<LightBoxContent lightBoxPosition={lightBoxPosition}>
						<Body {...props} />
					</LightBoxContent>
				</LightBox>
			</Scroll>
		)

	if (props.modalType === 'right-side') {
		return (
			<Scroll
				close={props.close}
				onScroll={onScroll}
				bgNoColor={props.header.bgNoColor}
				active={props.active}
				className={props.className}
				modalType={props.modalType}
				shouldCloseBg={props.shouldCloseBg}
				preventDefault={props.preventDefault}
			>
				<ContainerRightStyled
					className={'awesome-modal-container'}
					size={size}
					width={width}
					preventDefault={props.preventDefault}
				>
					<RowStyled
						gutterWidth={20}
						justify={justify}
						className={'awesome-modal-row'}
					>
						<Col md={size} className={'awesome-modal-col'}>
							<Body {...props} />
						</Col>
					</RowStyled>
				</ContainerRightStyled>
			</Scroll>
		)
	}

	return (
		<Scroll
			close={props.close}
			onScroll={onScroll}
			active={props.active}
			className={props.className}
		>
			<ContainerStyled
				className={'awesome-modal-container'}
				size={size}
				width={width}
			>
				<RowStyled
					gutterWidth={20}
					justify={justify}
					className={'awesome-modal-row'}
				>
					<Col md={size} className={'awesome-modal-col'}>
						<Body {...props} />
					</Col>
				</RowStyled>
			</ContainerStyled>
		</Scroll>
	)
}

const LightBoxContent = styled.div<{ lightBoxPosition: 'left' | 'right' }>`
	width: 50%;
	max-width: 670px;
	min-height: 100%;
	border-radius: 0;
	display: flex;

	${({ lightBoxPosition }) => {
		if (lightBoxPosition === 'left')
			return css`
				margin-right: auto;
			`
		return css`
			margin-left: auto;
		`
	}}
`

const LightBox = styled.div`
	width: 100%;
	height: 100%;
`

const ContainerRightStyled = styled.div<{
	size?: number
	width?: number | string
	preventDefault?: boolean
}>`
	display: flex;
	height: 100%;

	.awesome-modal-col {
		width: ${props => (props.width ? `${props.width}px` : '496px')} !important;
		max-width: ${props =>
			props.width ? `${props.width}px` : '496px'} !important;
		flex: 0 0 ${`100%`} !important;
	}

	${({ preventDefault }) =>
		preventDefault &&
		css`
			pointer-events: all;
		`}
`

const ContainerStyled = styled(Container)<{
	size?: number
	width?: number | string
}>`
	display: flex;
	height: 100%;

	${({ size, width }) =>
		(size || width) &&
		css`
			.awesome-modal-col {
				width: ${width ? `${width}px` : `${(size * 100) / 12}%`} !important;
				flex: 0 0 ${width ? `${width}px` : `${(size * 100) / 12}%`} !important;
				max-width: ${width ? `${width}px` : `${(size * 100) / 12}%`} !important;
			}
		`}
`

const RowStyled = styled(Row)`
	margin: auto;
	max-height: calc(100% - 100px);
	width: 100%;
`
